import { Injectable } from '@angular/core';

import { AutoReminderRule } from '../../models/auto-reminder-rule';

import { HttpClientService } from '../common/http-client.service';
import { BackendBaseService } from '../backend-base.service';

@Injectable({
  providedIn: 'root',
})
export class AutoReminderRuleService extends BackendBaseService {
  url: string = 'auto_reminder_rules';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  save(autoReminderRule: AutoReminderRule): Promise<any> {
    return super.save({
      id: autoReminderRule.id,
      auto_reminder_rule: autoReminderRule
    });
  }
}
